export default function ComparisonTable() {
  const rows = [
    { method: 'Google Suche', speed: 'Mittel', overview: 'Niedrig', beginner: 'Mittel' },
    { method: 'Einzelne Shopsuche', speed: 'Langsam', overview: 'Niedrig', beginner: 'Nein' },
    { method: 'OOPBUY Spreadsheet', speed: 'Schnell', overview: 'Sehr hoch', beginner: 'Ja' },
  ];

  const headers = ['Methode', 'Geschwindigkeit', 'Übersicht', 'Anfängerfreundlich'];

  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
            Vergleich der Einkaufsmethoden
          </h2>
          <div className="w-12 h-0.5 bg-primary-400 mx-auto mb-6"></div>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Das <strong>OOPBUY Spreadsheet</strong> bietet im Vergleich zu traditionellen Suchmethoden klare Vorteile.
          </p>
        </div>

        <div className="overflow-x-auto rounded-xl border border-background-200/60">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background-100">
                {headers.map((h) => (
                  <th key={h} className="px-5 py-3.5 text-left font-semibold text-foreground-800 whitespace-nowrap">
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row, idx) => (
                <tr
                  key={row.method}
                  className={`border-t border-background-200/40 ${
                    row.method === 'OOPBUY Spreadsheet'
                      ? 'bg-primary-50/60'
                      : idx % 2 === 0
                      ? 'bg-background-50'
                      : 'bg-background-100/50'
                  }`}
                >
                  <td className="px-5 py-3.5 font-medium text-foreground-900 whitespace-nowrap">
                    {row.method === 'OOPBUY Spreadsheet' ? (
                      <strong>{row.method}</strong>
                    ) : (
                      row.method
                    )}
                  </td>
                  <td className="px-5 py-3.5 text-foreground-600 whitespace-nowrap">{row.speed}</td>
                  <td className="px-5 py-3.5 text-foreground-600 whitespace-nowrap">{row.overview}</td>
                  <td className="px-5 py-3.5 text-foreground-600 whitespace-nowrap">{row.beginner}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}